<template>
<div>
    <Breadcrumbs main="Admin" submain="Course" title="Course" />
    <!-- Container-fluid starts -->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Course</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="course_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">

                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(title)="row">
                                        <div v-if="row.item.title" style="min-width: 200px; max-width: 400px; display: flex; flex-direction: column; gap: 6px;">
                                            <h7>{{ row.item.title }}</h7>
                                            <h7 v-if="row.item.link">
                                                <a
                                                    :href="row.item.link"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style="
                                                        display: inline-block;
                                                        padding: 2px 14px;
                                                        border-radius: 999px;
                                                        background: #f0f4ff;
                                                        color: #2563eb;
                                                        text-decoration: underline;
                                                        font-weight: 500;
                                                        font-size: 13px;
                                                        transition: background 0.2s;
                                                    "
                                                >
                                                    View Course
                                                </a>
                                            </h7>
                                        </div>
                                    </template>

                                    <template #cell(category)="row">
                                        <div v-if="row.item.category" style="min-width: 200px; display: flex; flex-direction: column; gap: 2px;">
                                            <h7>{{ row.item.category?.title }}</h7>
                                            <h7 v-if="row.item.sub_category">Sub: {{ row.item.sub_category?.title }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(cost)="row">
                                        <div style="min-width: 200px; max-width: 300px; display: flex; flex-direction: column; gap: 2px;">
                                            <h7>
                                                <b-badge :variant="row.item.own_asset ? 'success' : 'info'">
                                                    {{ row.item.own_asset ? 'Own Course' : 'External' }}
                                                </b-badge>
                                            </h7>
                                            <h7 style="margin-top: 4px" v-if="row.item.coin_cost && row.item.coin_cost !== 0"><span style="margin-top: 2px">Cost:</span> <b-badge>{{ row.item.coin_cost }}</b-badge></h7>
                                        </div>
                                    </template>

                                    <template #cell(partner)="row">
                                        <div v-if="row.item.own_asset === false && row.item.partner" style="min-width: 200px;">
                                            <a :href="row.item.partner?.link" target="_blank" rel="noopener noreferrer">
                                                <h7 style="font-size: 14px; font-weight: 500;">{{ row.item.partner?.title }}</h7>
                                            </a>
                                        </div>
                                        <div v-else>
                                            <!-- <h7 style="font-size: 14px; font-weight: 500;">QuickCV</h7> -->
                                        </div>
                                    </template>

                                    <template #cell(thumbnail)="row">
                                        <div v-if="row.item.thumbnail" style="min-width: 120px;">
                                            <img style="max-height: 80px;" :src="host + row.item.thumbnail" alt="">
                                        </div>
                                    </template>

                                    <!-- <template #cell(banner)="row">
                                        <div v-if="row.item.banner" style="min-width: 120px;">
                                            <img style="max-height: 80px;" :src="host + row.item.banner" alt="">
                                        </div>
                                    </template> -->

                                    <template #cell(created_on)="row">
                                        <div v-if="row.item.created_on" style="display: flex; flex-direction: column; gap: 4px;">
                                            <h7>{{ row.item.created_on.split('T')[0] }}</h7>
                                            <h7>{{ row.item.created_on.split('T')[1].split('.')[0] }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteCourse(data.item.slug)" title="Delete"></feather>
                                            </div>
                                            <div @click="editCourse(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Course Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Course" size="lg" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter course title" v-model="course.title">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Category</label>
                        <select class="form-control digits" v-model="course.category" @change="onCategoryChange(course.category)">
                            <option disabled value="">Select a category</option>
                            <option v-for="(type, index) in category_parent" :key="index" :value="type.id">{{ type.title }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group" v-if="category_list_by_parent && category_list_by_parent.length">
                        <label>Sub Category</label>
                        <select class="form-control digits" v-model="course.sub_category">
                            <option disabled value="">Select a category</option>
                            <option v-for="(type, index) in category_list_by_parent" :key="index" :value="type.id">{{ type.title }}</option>
                        </select>
                    </div>
                    <div class="form-group" v-else>
                        <label>Sub Category</label>
                        <select class="form-control digits" v-model="course.sub_category">
                            <option disabled value="">Select a category</option>
                            <option v-for="(type, index) in category_list" :key="index" :value="type.id">{{ type.title }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Link</label>
                        <input class="form-control" type="text" placeholder="Enter course link" v-model="course.link">
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Own Course?</label>
                        <select class="form-control" v-model="course.own_asset">
                            <option :value="true">Yes</option>
                            <option :value="false">No</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6" v-if="course.own_asset === false">
                    <div class="form-group">
                        <label>Partner</label>
                        <select class="form-control digits" v-model="course.partner">
                            <option disabled value="">Select a partner</option>
                            <option v-for="(type, index) in partner_list" :key="index" :value="type.id">{{ type.title }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Coin Cost</label>
                        <input class="form-control" type="number" placeholder="Enter course coin cost" v-model="course.coin_cost">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Description</label>
                        <textarea class="form-control" placeholder="Enter course description" v-model="course.description" rows="4"></textarea>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div style="display: flex; flex-direction: column;">
                        <label>Thumbnail Image</label>
                        <input type="file" accept="image/*" @change="onImageChange($event, 'thumbnail')" />
                    </div>
                    <div v-if="thumbnailPreview">
                        <img :src="thumbnailPreview" alt="Thumbnail Preview" style="max-width: 100%; max-height: 100px; margin-top: 8px;" />
                    </div>
                </div>
                <!-- <div class="col-sm-6">
                    <div style="display: flex; flex-direction: column;">
                        <label>Banner Image</label>
                        <input type="file" accept="image/*" @change="onImageChange($event, 'banner')" />
                    </div>
                    <div v-if="bannerPreview">
                        <img :src="bannerPreview" alt="Banner Preview" style="max-width: 100%; max-height: 100px; margin-top: 8px;" />
                    </div>
                </div> -->
            </div>
        </form>
    </b-modal>

    <!-- Course Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Course" size="lg" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter course title" v-model="edit_course.title">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Category</label>
                        <select class="form-control digits" v-model="edit_course.category" @change="onCategoryChange(edit_course.category)">
                            <option disabled value="">Select a category</option>
                            <option v-for="(type, index) in category_parent" :key="index" :value="type.id">{{ type.title }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group" v-if="category_list_by_parent && category_list_by_parent.length">
                        <label>Sub Category</label>
                        <select class="form-control digits" v-model="edit_course.sub_category">
                            <option disabled value="">Select a category</option>
                            <option v-for="(type, index) in category_list_by_parent" :key="index" :value="type.id">{{ type.title }}</option>
                        </select>
                    </div>
                    <div class="form-group" v-else>
                        <label>Sub Category</label>
                        <select class="form-control digits" v-model="edit_course.sub_category">
                            <option disabled value="">Select a category</option>
                            <option v-for="(type, index) in category_list" :key="index" :value="type.id">{{ type.title }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Link</label>
                        <input class="form-control" type="text" placeholder="Enter course link" v-model="edit_course.link">
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Own Course?</label>
                        <select class="form-control" v-model="edit_course.own_asset">
                            <option :value="true">Yes</option>
                            <option :value="false">No</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6" v-if="edit_course.own_asset === false">
                    <div class="form-group">
                        <label>Partner</label>
                        <select class="form-control digits" v-model="edit_course.partner">
                            <option disabled value="">Select a partner</option>
                            <option v-for="(type, index) in partner_list" :key="index" :value="type.id">{{ type.title }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Coin Cost</label>
                        <input class="form-control" type="number" placeholder="Enter course coin cost" v-model="edit_course.coin_cost">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Description</label>
                        <textarea class="form-control" placeholder="Enter course description" v-model="edit_course.description" rows="4"></textarea>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div style="display: flex; flex-direction: column;">
                        <label>Thumbnail Image</label>
                        <input type="file" accept="image/*" @change="onImageChangeEdit($event, 'thumbnail')" />
                    </div>
                    <div v-if="thumbnailPreview" style="margin-top: 20px;">
                        <img :src="thumbnailPreview" alt="Thumbnail Preview" style="max-width: 100%; max-height: 100px;" />
                    </div>
                </div>
                <!-- <div class="col-sm-6">
                    <div style="display: flex; flex-direction: column;">
                        <label>Banner Image</label>
                        <input type="file" accept="image/*" @change="onImageChangeEdit($event, 'banner')" />
                    </div>
                    <div v-if="bannerPreview" style="margin-top: 20px;">
                        <img :src="bannerPreview" alt="Banner Preview" style="max-width: 100%; max-height: 100px;" />
                    </div>
                </div> -->
            </div>
        </form>
    </b-modal>

    <!-- Course Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this course?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../../_helpers/host';
import loader from '../../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'category',
                    label: 'Category',
                    sortable: true
                },
                {
                    key: 'cost',
                    label: 'Cost',
                    sortable: true
                },
                {
                    key: 'partner',
                    label: 'Partner',
                    sortable: true
                },
                {
                    key: 'thumbnail',
                    label: 'Thumbnail',
                    sortable: true
                },
                // {
                //     key: 'banner',
                //     label: 'Banner',
                //     sortable: true
                // }, 
                // {
                //     key: 'created_on',
                //     label: 'Created On',
                //     sortable: true
                // },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            course: {
                title: "",
                category: null,
                sub_category: null,
                link: "",
                partner: null,
                own_asset: false,
                coin_cost: 0,
                description: "",
                thumbnail: null,
                // banner: null
            },
            edit_course: {
                slug: null,
                title: "",
                category: null,
                sub_category: null,
                link: "",
                partner: null,
                own_asset: false,
                coin_cost: 0,
                description: "",
                thumbnail: null,
                // banner: null
            },
            thumbnailPreview: null,
            // bannerPreview: null,
            delete_value: null,

            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20]
        };
    },

    computed: {
        ...mapState({
            course_list: state => state.course.course,
            partner_list: state => state.partner.partner,
            loading: state => state.course.courseLoading,
            error: state => state.course.courseError,
            category_list: state => state.course.category,
            category_parent: state => state.course.category_parent,
            category_list_by_parent: state => state.course.category_list_by_parent
        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {
        this.$store.dispatch("course/fetchCategoryParent")
        this.$store.dispatch("course/fetchCategory")
        this.$store.dispatch("partner/fetchPartner")
        this.$store.dispatch("course/fetchCourse").then(() => {
            this.items = this.course_list
            this.totalRows = this.course_list.length;
        });
    },

    methods: {
        onImageChange(e, type) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                if(type == 'thumbnail') {
                    this.course.thumbnail = e.target.result;
                    this.thumbnailPreview = e.target.result;
                } else {
                    // this.course.banner = e.target.result;
                    // this.bannerPreview = e.target.result;
                }
            };
        },

        onImageChangeEdit(e, type) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                if(type == 'thumbnail') {
                    this.edit_course.thumbnail = e.target.result;
                    this.thumbnailPreview = e.target.result;
                } else {
                    // this.edit_course.banner = e.target.result;
                    // this.bannerPreview = e.target.result;
                }
            };
        },

        onCategoryChange(id) {
            this.$store.dispatch("course/fetchSubCategory", id)
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.course.title = ""
            this.course.category = null
            this.course.sub_category = null
            this.course.link = ""
            this.course.partner = null
            this.course.own_asset = false
            this.course.cost = 0
            this.course.description = ""
            this.course.thumbnail = null
            this.thumbnailPreview = null
            // this.course.banner = null
            // this.bannerPreview = null
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("course/addCourse", {
                course: this.course
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editCourse(detail) {
            this.edit_course.slug = detail.slug ? detail.slug : null
            this.edit_course.title = detail.title ? detail.title : null
            this.edit_course.category = detail.category ? detail.category.id : null
            this.edit_course.sub_category = detail.sub_category ? detail.sub_category.id : null
            this.edit_course.link = detail.link ? detail.link : null
            this.edit_course.partner = detail.partner ? detail.partner.id : null
            this.edit_course.own_asset = detail.own_asset ? detail.own_asset : false
            this.edit_course.coin_cost = detail.coin_cost ? detail.coin_cost : 0
            this.edit_course.description = detail.description ? detail.description : null
            this.thumbnailPreview = detail.thumbnail ? this.host + detail.thumbnail : null
            // this.bannerPreview = detail.banner ? this.host + detail.banner : null
        },

        resetEditModal() {
            this.edit_course.title = ""
            this.edit_course.category = null
            this.edit_course.sub_category = null
            this.edit_course.link = ""
            this.edit_course.partner = null
            this.edit_course.own_asset = false
            this.edit_course.coin_cost = 0
            this.edit_course.description = ""
            this.edit_course.thumbnail = null
            this.thumbnailPreview = null
            // this.edit_course.banner = null
            // this.bannerPreview = null
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("course/updateCourse", {
                id: this.edit_course.slug,
                course: this.edit_course
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        deleteCourse(slug) {
            this.delete_value = slug
        },

        handleDeleteOk() {
            this.$store.dispatch("course/deleteCourse", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
